import flatten from 'ramda/src/flatten';
import { SUPPORTED_DOCUMENT_FILE_TYPES } from 'util/constants';
import { splitFilenameExtension } from 'util/stringUtils';

const mimeTypes = flatten(SUPPORTED_DOCUMENT_FILE_TYPES.map(m => m.mimes));

export const isAllowedFiletype = (type: string) => {
  return mimeTypes.some((m: string) => m === type);
};

export const isImageFile = (filename: string): boolean => {
  const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'];
  const { extension } = splitFilenameExtension(filename);
  return imageExtensions.includes(extension?.toLowerCase() || '');
};
